module.exports = __webpack_public_path__ + "static/media/nurse_doctor_ipad.cc067c64.png";